import { FC, useState, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import classNames from "classnames";
import { useDebouncedCallback } from "use-debounce";

import { TitleWithForm } from "../index";
import { TitleWithFormRelatedBrandsProps } from "./types";
import RelatedBrands from "../RelatedBrands/RelatedBrands";
import { LogoResponse } from "../../store/brands/types";
import { fetchRelatedBrands, resetRelatedBrands } from "../../store/auth/slice";
import { AddFormItem } from "../AddForm/types";
import { mapToAddFormItem } from "../AddForm/utils/mapToAddFormItem";

import styles from "./TitleWithFormRelatedBrands.module.css";



const TitleWithFormRelatedBrands: FC<TitleWithFormRelatedBrandsProps> = ({ className, ...props }) => {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState<AddFormItem>(mapToAddFormItem(''));
  const [isOpenRelatedBrands, setIsOpenRelatedBrands] = useState(false);
  const relatedBrandsRef = useRef<HTMLDivElement>(null);
  const debouncedFetch = useDebouncedCallback((value: string) => dispatch(fetchRelatedBrands({ brand: value })), 300);

  useEffect(() => {
    return () => {
      dispatch(resetRelatedBrands());
    }
  }, []);

  const handleInput = (value: AddFormItem) => {
    const { label: name } = value;
    setSearchValue(mapToAddFormItem(name));
    if (name) debouncedFetch(name);
    else dispatch(resetRelatedBrands());
  }

  const handleOutsideClick = (e?: MouseEvent | TouchEvent) => {
    if (e) {
      const target = e.target as Node | null;
      if (relatedBrandsRef.current && target && relatedBrandsRef.current.contains(target)) {
        return;
      }
    }
    setIsOpenRelatedBrands(false);
  }

  return (
    <div className={classNames(styles.form, className)}>
      <TitleWithForm
        onFocus={() => setIsOpenRelatedBrands(true)}
        onOutsideClick={handleOutsideClick}
        onInput={handleInput}
        value={searchValue}
        {...props}
      />
      {isOpenRelatedBrands && (
        <div ref={relatedBrandsRef}>
          <RelatedBrands
            className={styles.form__related}
            onSelect={(brandSelected: LogoResponse) => {
              setSearchValue(mapToAddFormItem(brandSelected.name, brandSelected));
              setIsOpenRelatedBrands(false);
            }}
          />
        </div>
      )}
    </div>

  );
};

export default TitleWithFormRelatedBrands;